import React from "react";
import Carousel from "react-multi-carousel";
import { BsCircleFill } from "react-icons/bs";
import "react-multi-carousel/lib/styles.css";
import { companyData } from "../../../data/CompanyData";
const SuccessStory = () => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 900 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 900, min: 640 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
    },
  };
  return (
    <div className="border-t border-t-gray-200 py-10 ">
      <div className="flex justify-between flex-wrap gap-2 mb-2">
        <div>
          <h3 className="text-2xl font-bold">
            We're proud of our success stories
          </h3>
          <p className="text-accent">
            Case studies from some of our amazing customers who are building who
            are building faster
          </p>
        </div>
        <button className="btn btn-m btn-primary text-white">
          Create account
        </button>
      </div>
      <div className="my-5">
        <Carousel
          infinite={true}
          autoPlaySpeed={3000}
          autoPlay={true}
          keyBoardControl={true}
          responsive={responsive}
          dotListClass="custom-dot-list-style"
          containerClass="carousel-container"
          itemClass="carousel-item-padding-40-px"
        >
          {companyData.map((item, index) => (
            <div
              key={index}
              className="h-[400px] flex justify-between flex-col text-white p-6 bg-primary"
            >
              <p className="text-lg flex items-center gap-2">
                <BsCircleFill className="text-white" /> {item.company}
              </p>
              <div className="bg-white bg-opacity-10 p-4">
                <h3 className="text-xl font-bold my-1">{item.title}</h3>
                <p className="text-sm mb-1">{item.text}</p>
                <a href={item.link} className="flex items-center gap-2 text-sm">
                  Read case study
                </a>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default SuccessStory;
